const c="#f1faff",a="#0072c3",f="#c5cbd1",b="#a2a9b0",d="#697077",o="#21272a",t="#dc3545";export{f as ColorBlueGray40,b as ColorBlueGray50,d as ColorBlueGray70,o as ColorBlueGray90,c as ColorCyan10,a as ColorCyan70,t as ColorRed60};
